import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import UserRolesList from '../UserRolesList';
import PermissionsList from '../PermissionsList';
import CreateRoleModal from '../CreateRoleModal';
import EditRoleForm from '../EditRoleForm';
import Loading from '../Loading';
import { AdminRolesPermissionsWrapper, AdminRolesTopMenu, AdminRolesContentWrapper, AdminRolesContentLhs, AdminRolesContent } from 'src/components/AdminRolesAndPermissions/AdminRolesAndPermissions.style.ts';

class AdminRolesAndPermissions extends React.Component {
    static propTypes = {
        onPermissionsGetRequest: PropTypes.func,
        onRolesGetRequest: PropTypes.func,
        onRoleUpdateRequest: PropTypes.func,
        onRoleDeleteRequest: PropTypes.func,

        roles: ImmutablePropTypes.map,
        permissions: ImmutablePropTypes.map,

        editing: PropTypes.bool,
        loading: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedRole: null,
            newRoles: null,
            showCreateModal: false
        };
    }

    componentDidMount() {
        this.props.onPermissionsGetRequest();
        this.props.onRolesGetRequest();
    }

    UNSAFE_componentWillReceiveProps({ roles }) {
        if (!this.state.selectedRole && roles) {
            this.setState({
                selectedRole: roles.first() && roles.first().get('id')
            });
        }
    }

    selectRole(role) {
        this.setState({
            selectedRole: role.get('id')
        });
    }

    showRoleCreateModal() {
        this.setState({
            showCreateModal: true
        });
    }

    hideCreateRoleModal() {
        this.setState({
            showCreateModal: false
        });
    }

    edit() {
        this.setState({
            editing: true
        });
    }

    del() {
        this.props.onRoleDeleteRequest(this.state.selectedRole);
    }

    save(data) {
        this.props.onRoleUpdateRequest(data);
        this.setState({
            editing: false
        });
    }

    render() {
        let { selectedRole, editing } = this.state;

        let content;
        selectedRole = this.props.roles.get(selectedRole);

        if (selectedRole) {
            content = editing ? (
                <EditRoleForm
                    role={ selectedRole }
                    onSubmit={ this.save.bind(this)}
                    permissions={ this.props.permissions }
                    onDeleteRequest={ this.del.bind(this)}
                />
            ) : (
                <div className='admin-roles-permissions__preview'>
                    <h3>Permissions</h3>
                    <PermissionsList
                        grants={ selectedRole.get('grants') }
                        title={ selectedRole.get('name') }
                        permissions={ this.props.permissions }
                        disabled={ true }
                    />
                    <div className='admin-roles-permissions__menu'>
                        <button className='btn' onClick={ this.edit.bind(this)}>Edit</button>
                    </div>
                </div>
            );
        }

        return (
            <AdminRolesPermissionsWrapper className='admin-roles-permissions'>
                <AdminRolesTopMenu>
                    <button
                        className='btn btn-add '
                        onClick={ this.showRoleCreateModal.bind(this)}>
                        Add role
                    </button>
                </AdminRolesTopMenu>
                
                <AdminRolesContentWrapper>
                    <AdminRolesContentLhs className='admin-roles-permissions__roles-section'>
                        <UserRolesList
                            onRoleSelect={ this.selectRole.bind(this)}
                            roles={ this.props.roles }
                            editing={ false }
                            disabled={ false }
                        />
                    </AdminRolesContentLhs>

                    <AdminRolesContent>
                        <div className='admin-roles-permissions__permissions-section'>
                            { content }
                        </div>
                    </AdminRolesContent>
                </AdminRolesContentWrapper>

                <CreateRoleModal
                    onClose={ this.hideCreateRoleModal.bind(this)}
                    onFinish={ this.hideCreateRoleModal.bind(this)}
                    active={ this.state.showCreateModal }
                />
                <Loading active={ this.props.loading } />
            </AdminRolesPermissionsWrapper>
        );
    }
}

export default AdminRolesAndPermissions;
